type TDataLayerItem = { p?: { t?: unknown } } | undefined;

/**
 * The GA page type (`p.t`) of the latest dataLayer push. SPAs (LRP) push a new one on every
 * client-side navigation, so the last one is the current page.
 */
const getPageType = (): string | undefined => {
  const dataLayer = (window as { dataLayer?: TDataLayerItem[] }).dataLayer;
  if (!Array.isArray(dataLayer)) {
    return undefined;
  }
  for (let i = dataLayer.length - 1; i >= 0; i -= 1) {
    const pageType = dataLayer[i]?.p?.t;
    if (typeof pageType === 'string' && pageType) {
      return pageType;
    }
  }
  return undefined;
};

export default getPageType;
